import styles from './AuthLayout.module.css';

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className={styles.page}>
      <div className={styles.heroBg} />
      <div className={styles.card}>
        {/* Full-lockup logo (symbol + wordmark in one PNG).
            Replaces the prior split brandRow (symbol-only +
            separate text span) since the new lockup includes
            the EV INITIATIVE wordmark rendered as part of the
            image. Centered + large to anchor the auth surface. */}
        <div className={styles.brandRow}>
          <img src="/evi-logo.png" alt="EV Initiative" className={styles.logo} />
        </div>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
